<template>
    <div class="search-results-intro col-12 col-lg-8">
        <h1 class="search-results-intro-headline">{{ headline }}</h1>
        <div class="search-results-intro-input">
            <input class="js-search-input" type="text" name="query" v-on:keyup.enter="search" v-model="query" aria-label="Search" />
            <button type="button" class="search-results-intro-input-button" v-on:click="getResults(specification)"><img src="/images/icon-search.svg" alt="Search Icon" /></button>
        </div>
    </div>
    <div class="search-results-body col-12 col-lg-8">
        <div class="search-results-no-results" v-if="!pages">
            <p>No results found for {{ (specification && specification.query) || 'your search' }}</p>
        </div>
        <div class="search-results-body-item" v-for="(item, index) in results.items" v-else>
            <h2 class="search-results-body-item-name"><a v-bind:href="item.relativeUrl">{{ item.name }}</a></h2>
            <p class="search-results-body-item-copy">{{ item.copy }}</p>
        </div>
    </div>
    <div class="search-results-pagination col-12 col-lg-8" v-if="pages">
        <ul>
            <li class="search-results-pagination-prev search-results-pagination-arrow" v-if="results.pageNumber != 1"><a href="#" v-on:click="changePage($event, (results.pageNumber-1))"><img src="/images/icon-chevron-gray.svg" alt="Previous page icon"/></a></li>
            <li v-bind:class="results.pageNumber === page ? 'search-results-pagination-item--active search-results-pagination-item' : 'search-results-pagination-item'" v-for="page in pages"><a href="#" v-on:click="changePage($event, page)">{{ page }}</a></li>
            <li class="search-results-pagination-next search-results-pagination-arrow" v-if="results.pageNumber != pages"><a href="#" v-on:click="changePage($event, (results.pageNumber+1))"><img src="/images/icon-chevron-gray.svg" alt="Next page icon" /></a></li>
        </ul>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                headline: window.CFCU.Headline,
                pages: 0,
                results: window.CFCU.Results,
                specification: window.CFCU.Specification,
                query: '',
            }
        },
        mounted() {
            if (!this.specification) {
                this.specification = {
                    query: '',
                    pageSize: 20,
                    pageNumber: 1,
                }
            }

            if (!this.results) {
                this.results = {
                    items: [],
                    totalCount: 0,
                    pageNumber: 1
                }
            }

            if (this.specification.pageSize === null) {
                this.specification.pageSize = 20;
            }

            this.setPages();
        },
        methods: {
            changePage(event, page) {
                event.preventDefault();
                this.specification.pageNumber = page;
                this.getResults(this.specification);
                this.updateUrl();
            },
            getResults(specification) {
                axios
                    .get(`/api/search?query=${specification.query}&pageNumber=${specification.pageNumber}&pageSize=${specification.pageSize}`)
                    .then((response) => {
                        this.results = response.data;
                        this.setPages();
                        this.updateUrl();
                        this.scrollToTop();
                    });
            },
            search() {
                this.specification.query = this.query;
                this.specification.pageNumber = 1;
                this.getResults(this.specification);
            },
            scrollToTop() {
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            },
            setPages() {
                this.pages = Math.ceil(this.results.totalCount / this.specification.pageSize);
            },
            updateUrl() {
                // Encode data for url parameters
                const encodeDataToURL = (data) => {
                    const value = Object
                        .keys(data)
                        .map(value => `${value}=${encodeURIComponent(data[value])}`)
                        .join('&');

                    return value;
                };

                // Function to remove null or empty values
                const removeEmpty = (obj) => {
                    const newObj = [];

                    Object.keys(obj).forEach(key => {
                        if (obj[key] && typeof obj[key] === 'object') {
                            newObj[key] = removeEmpty(obj[key]);
                        }
                        else if (obj[key] !== null && obj[key] !== '') {
                            if (obj[key] !== '999') {
                                newObj[key] = obj[key];
                            }
                        }
                    });

                    return newObj;
                };

                // Remove empty specifications
                const specification = removeEmpty(this.specification);

                // Create URL
                let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${encodeDataToURL(specification)}`;

                // Update URL
                window.history.pushState({ path: newUrl }, '', newUrl);
            }
        },
        watch: {
            
        }
    }
</script>